export type KeyObject<T extends object> = {
  [k in keyof T]?: T[k] | T[k][]
}

export class KeyObjectStore<TKeyObject extends object, TData> {
  #content: { keyObject: KeyObject<TKeyObject>; data: TData }[] = []

  #tryGetData(queryObject: KeyObject<TKeyObject>) {
    return this.#content.find((contentItem) => {
      return Object.entries(contentItem.keyObject).every(([key, values]) => {
        const keyValueArray = Array.isArray(values) ? values : [values]

        const queryUnknown = queryObject[key as keyof TKeyObject]
        const queryValueArray = Array.isArray(queryUnknown) ? queryUnknown : [queryUnknown]

        return keyValueArray.some((keyValue) => {
          return queryValueArray.some((queryValue) => {
            if (typeof keyValue !== typeof queryValue) return false
            if (typeof keyValue === 'string') {
              return keyValue.toLowerCase() === (queryValue as string).toLowerCase()
            } else {
              return keyValue === queryValue
            }
          })
        })
      })
    })?.data
  }

  register(keyObject: KeyObject<TKeyObject>, data: TData) {
    if (this.#tryGetData(keyObject)) throw new Error('Objet déja référencé', { cause: keyObject })
    this.#content.push({ keyObject, data })
  }

  tryGetData(queryObject: KeyObject<TKeyObject>) {
    return this.#tryGetData(queryObject)
  }

  getData(queryObject: KeyObject<TKeyObject>) {
    const data = this.tryGetData(queryObject)
    if (!data) throw new Error('Objet inexistant', { cause: queryObject })
    return data
  }
}
